import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/theme/theme-warm.css";
import "@/theme/theme-apple.css";
import App from "@/App";
import { installAuthInterceptors } from "@/lib/authInterceptors";

installAuthInterceptors();

// Eagerly register Service Worker (used for Web Push + PWA install).
// Safe to skip in unsupported browsers; subscription only happens on user opt-in.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* silent */ });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
